import {translations} from 'presentation/translations-new';

const {
	filteredNetwork: {titlePart1, titlePart2, emptyUnit},
	unit,
	units,
} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

const getUnitsByDistanceTitle = (listLength: number, localityDistance: string): string => {
	const listIsEmpty = !listLength || listLength === 0;
	const unitLabel = listLength > 1 ? units : unit;

	const unitsText = listIsEmpty
		? emptyUnit
		: `${String(listLength).padStart(2, '0')} ${unitLabel}`;

	return `${unitsText} ${titlePart1} ${localityDistance}${titlePart2}`;
};

export {getUnitsByDistanceTitle};
